// import logo from "./logo.svg";
import React from "react";
import "./App.css";
import { Route, Switch } from "react-router-dom";
import HomePage from "./screens/homePage";
import ProductPage from "./screens/productPage";
import CartPage from "./screens/cartPage";
import CartTest from "./screens/cartTest";
import SigninPage from "./screens/signinPage";
import RegisterPage from "./screens/registerPage";
import ShippingPage from "./screens/shippingPage";
import PaymentPage from "./screens/paymentPage";
import PlaceorderPage from "./screens/placeOrderPage";
import OrderPage from "./screens/orderPage";
import ProfilePage from "./screens/profilePage";
import OrderhistoryPage from "./screens/orderhistoryPage";
import PrivateRoute from "./components/privateRoute";
import ProductEditPage from "./screens/ProductEditPage";
import AdminRoute from "./components/adminRoute";
import ProductListPage from "./screens/productListPage";
import OrderListPage from "./screens/orderListPage";
import SearchPage from "./screens/searchPage";

function App() {
  return (
    <Switch>
      <Route path="/signin" component={SigninPage} />
      <Route path="/register" component={RegisterPage} />
      <Route path="/cart/:id?" component={CartPage} />
      <Route path="/products/:id" component={ProductPage} exact />
      <Route
        path="/products/:id/edit"
        component={ProductEditPage}
        exact
      ></Route>
      <Route path="/cart" component={CartTest} />
      <Route path="/shipping" component={ShippingPage} />
      <Route path="/payment" component={PaymentPage} />
      <Route path="/orders/:id" component={OrderPage} />
      <Route path="/orderhistory" component={OrderhistoryPage}></Route>
      <Route path="/placeorder" component={PlaceorderPage} />
      <Route path="/search/name/:name?" component={SearchPage} exact></Route>
      <Route
        path="/search/category/:category"
        component={SearchPage}
        exact
      ></Route>
      <Route
        path="/search/category/:category/name/:name"
        component={SearchPage}
        exact
      ></Route>
      <Route
        path="/search/category/:category/name/:name/min/:min/max/:max/order/:order/pageNumber/:pageNumber"
        component={SearchPage}
        exact
      ></Route>
      <PrivateRoute path="/profile" component={ProfilePage}></PrivateRoute>
      <AdminRoute
        path="/productlist"
        component={ProductListPage}
        exact
      ></AdminRoute>
      <AdminRoute
        path="/productlist/pageNumber/:pageNumber"
        component={ProductListPage}
        exact
      ></AdminRoute>
      <AdminRoute path="/orderlist" component={OrderListPage}></AdminRoute>

      <Route path="/" component={HomePage} />
    </Switch>
  );
}

export default App;
